import {
  ETAT_FACTURE,
  ETAT_ENREGISTRE,
  ETAT_FACTURE_PARTIELLEMENT,
  SENS_VENTE,
  TYPE_COMMANDE,
} from '@/configuration/devisConf';

import { STORE_NAME_PLAN_MEDIA_VENTE, STORE_NAME_COMMANDE_LIGNES_COMMANDE } from '@/configuration/commande/commandeConf';

export default function genererCritereRecherche(nameStore) {
  const criteres = {
    client: '',
    code: '',
    codePM: '',
    codesDossier: [],
    etatsDevisCommandeFacture: [],
    datesPremierAffichage: {
      dateDebut: null,
      dateFin: null,
    },
    agencesId: [],
    commercialId: null,
    assistantId: null,
    referenceIds: [],
    ids: [],
    groupeIds: [],
    enseigneIds: [],
    produit: '',
    autoRecherche: '',
    sens: SENS_VENTE,
    libelle: '',
    typesProduits: [],
    fournisseursId: [],
    tiersId: [],
    interne: false,
    produitsIds: [],
    typesDevisCommandeFacture: [],
    produitRegroupementIds: [],
    typesProduitRegroupement: [],
    secteurIds: [],
  };
  if (nameStore === STORE_NAME_PLAN_MEDIA_VENTE) {
    criteres.etatsDevisCommandeFacture = [];
    criteres.typesDevisCommandeFacture = [];
  } else if (!nameStore || nameStore === STORE_NAME_COMMANDE_LIGNES_COMMANDE) {
    criteres.etatsDevisCommandeFacture = [
      ETAT_ENREGISTRE,
      ETAT_FACTURE,
      ETAT_FACTURE_PARTIELLEMENT,
    ];
    criteres.typesDevisCommandeFacture = [TYPE_COMMANDE];
  }
  return criteres;
}
